import { render } from "./TransactionHistory.vue?vue&type=template&id=5e496ac6&ts=true"
import script from "./TransactionHistory.vue?vue&type=script&lang=ts"
export * from "./TransactionHistory.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__